export default __webpack_public_path__ + "media/images/images/carousel/09-09543fe39c49487a142f65305c10df33.jpg";